/**
 * ZohoTicketStatusSection — Iter 146 (Feb 2026). Extracted Iter 156.9.
 *
 * Renders the Zoho 4-state status picker (Open / On Hold / Escalated /
 * Closed) inside the linked-lead panel so an email agent has the same
 * one-click status control they had on the ticket header, even while
 * focused on the right rail. Visually matches the WATI Ticket Status
 * section from ChatRightPanel so the swap is invisible to muscle memory.
 */
const ZOHO_STATUSES = [
  { key: "Open",      bg: "#DBEAFE", text: "#1E40AF", border: "#93C5FD" },
  { key: "On Hold",   bg: "#FEF3C7", text: "#B45309", border: "#FCD34D" },
  { key: "Escalated", bg: "#FEE2E2", text: "#B91C1C", border: "#FCA5A5" },
  { key: "Closed",    bg: "#D1FAE5", text: "#047857", border: "#6EE7B7" },
];

export default function ZohoTicketStatusSection({ currentStatus, onChange, loading }) {
  return (
    <div>
      <h4 className="text-[10px] font-extrabold text-[--text-muted] uppercase tracking-wider mb-2">
        Zoho Ticket Status
      </h4>
      <div className="grid grid-cols-2 gap-1" data-testid="zoho-status-panel">
        {ZOHO_STATUSES.map((s) => {
          const active = currentStatus === s.key;
          return (
            <button
              key={s.key}
              onClick={() => !loading && onChange && onChange(s.key)}
              disabled={loading}
              className={`px-2 py-1.5 rounded-lg text-[10px] font-bold transition-all border-2 disabled:opacity-50 ${
                active ? "shadow-sm" : "bg-white border-[--border-dark] text-[--text-muted] hover:border-gray-300"
              }`}
              style={active ? { background: s.bg, color: s.text, borderColor: s.border } : {}}
              data-testid={`zoho-status-btn-${s.key.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {s.key}
            </button>
          );
        })}
      </div>
      <p className="text-[9px] text-[--text-muted] mt-1">Syncs to Zoho Desk on click.</p>
    </div>
  );
}
